module.exports = __webpack_public_path__ + "media/components/common/images/pencil-d6fd137fc388acb49f8b6ce0d1e2527d.png";